module.exports = __webpack_public_path__ + "static/media/ProgressiveRelaxationActivity.daf17e8b.mp3";